import React, { useState, useRef, forwardRef, useImperativeHandle, useEffect } from 'react';

import css from './VideoBg.module.css';

const VideoBg = forwardRef((props, ref) => {
  const { src, type, isLandscapeHero = false } = props;
  const [isPlaying, setIsPlaying] = useState(true);
  const videoRef = useRef(null);

  const togglePlayPause = () => {
    if (!isLandscapeHero) return;

    if (videoRef.current) {
      if (videoRef.current.paused || videoRef.current.ended) {
        videoRef.current.play();
        setIsPlaying(true);
      } else {
        videoRef.current.pause();
        setIsPlaying(false);
      }
    }
  };

  useImperativeHandle(ref, () => ({
    togglePlayPause,
    get isPlaying() {
      return isPlaying;
    }
  }));

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const handlePlay = () => setIsPlaying(true);
    const handlePause = () => setIsPlaying(false);

    video.addEventListener('play', handlePlay);
    video.addEventListener('pause', handlePause);

    return () => {
      video.removeEventListener('play', handlePlay);
      video.removeEventListener('pause', handlePause);
    };
  }, []);

  return (
    <div className={css.wrapper}>
      <video
        ref={videoRef}
        autoPlay
        muted
        loop
        playsInline
        className={css.video}
        onClick={togglePlayPause}
      >
        <source src={src} type={type} />
      </video>
      <div className={css.overlay}></div>
    </div>
  );
});

export default VideoBg;
